import { apiUrl } from 'constants/main';

const baseUrl = `${apiUrl}/templates`;

export default baseUrl;
